/**
 * @module
 */
module.exports = {
  OTHER: 'other',
};
